// extracted by mini-css-extract-plugin
module.exports = {"body":"body__3PY6u"};